// extracted by mini-css-extract-plugin
export default {"trigger":"multi-section-editor_trigger__nmSK3","container":"multi-section-editor_container__l4ACY"};